import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingCond } from '../constants/constants';

@Pipe({ name: 'colorMappingCond' })
export class ColorMappingCondPipe implements PipeTransform {
  transform(value: number, greenTableDesign: boolean) {
    return colorMappingCond(value, greenTableDesign);
  }
}
